import { gql } from '@apollo/client/core';

export const getPayersQuery = gql`
  query GetPayers(
    $first: Int!
    $where: PayerFilterInput
    $order: [PayerSortInput!]
    $after: String
  ) {
    payers(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        apg
        attachmentEnrollment
        attachments
        attachmentSplit
        attachmentsProcessorId
        attachmentType
        batchClaimStatus
        billingIndicator
        cardId
        city
        claimFilingIndicator
        claimStatus
        claimStatusEnrollment
        claimStatusId
        claimStatusType
        contactEmail
        contactFax
        contactName
        contactPhone
        dateLastDbUpdate
        dateLastFile
        dateLastStatement
        dateSetup
        dateTerminate
        dentalProcessorId
        doesEligibility
        eligibilityEnrollment
        eligibilityType
        eraEnrollment
        eraType
        followUpNumberOfDays
        groupEnrolled
        # groupEnrollments,
        icd10
        icd10EffectiveDate
        id
        institutionalEnrollment
        institutionalType
        legacy
        name
        neicId
        neicOffice
        neicPayerType
        nexia
        notes
        npiIndicator
        payorState
        payorType
        # preferredRoutings,
        processorId
        publishEra
        publishInstitutional
        publishProfessional
        realTimeId
        recordStatus
        requiresEnrollment
        secondaryClaims
        state
        ubProcessorId
        webUrl
        zipCode
      }
    }
  }
`;
